// 고객 화면 머리의 전화 링크 — 폰은 tap-target 으로 40px(상자는 그대로라 머리 높이가 안 늘어난다) · 회사명과 한 줄에 둘 때만 쓴다(CustomerHeadOrg).
export const TEL_LINK_CLASS = "tap-target relative shrink-0 text-xs text-muted-foreground underline-offset-2 hover:underline";

const TelLink = ({ tel }: { tel: string }) => (
  <a className={TEL_LINK_CLASS} data-testid="customer-tel-link" href={`tel:${tel}`}>
    {tel}
  </a>
);

export default TelLink;
